<template>
  <div>
    <h1 class="text-center">Preguntas</h1>
    <new-question @newQuestion="resetValues" />
    <div class="mt-4">
      <div v-if="isLoggedIn" class="d-flex justify-content-center mb-2">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button
            type="button"
            :class="{'active': filter == FILTER_ALL}"
            @click="handleFilter(FILTER_ALL)"
            class="btn btn-secondary"
          >Todas</button>
          <button
            type="button"
            :class="{'active': filter == FILTER_OWN}"
            @click="handleFilter(FILTER_OWN)"
            class="btn btn-secondary"
          >Mis preguntas</button>
        </div>
      </div>
      <template v-if="total > 0">
        <div class="list-group">
          <question v-for="(question, index) in questions" :key="index" :question="question" />
        </div>
      </template>
      <div
        v-else-if="total === 0"
        class="alert alert-primary text-center h2"
        role="alert"
      >Aún no hay preguntas por aquí</div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="no-more"></div>
        <div slot="no-results"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import { getQuestionsApi } from "@/api/modules";
import { mapActions, mapGetters } from "vuex";
const InfiniteLoading = () => import("vue-infinite-loading");
const Question = () => import("./Question");
const NewQuestion = () => import("./New");
const ITEMS_PER_PAGE = 8;
const FILTER_ALL = 0;
const FILTER_OWN = 1;
export default {
  data() {
    return {
      filter: 0,
      page: 1,
      infiniteId: +new Date(),
      questions: [],
      total: null
    };
  },
  components: {
    InfiniteLoading,
    Question,
    NewQuestion
  },
  computed: {
    ...mapGetters(["isLoggedIn"])
  },
  created() {
    this.FILTER_ALL = FILTER_ALL;
    this.FILTER_OWN = FILTER_OWN;
  },
  methods: {
    ...mapActions(["addMessage"]),
    resetValues() {
      this.questions = [];
      this.infiniteId++;
      this.page = 1;
    },
    async infiniteHandler($state) {
      const status = await this.getQuestions();
      if (status) {
        if (this.total === this.questions.length) $state.complete();
        else $state.loaded();
      } else $state.error();
    },
    handleFilter(filter) {
      if (filter != this.filter) {
        this.filter = filter;
        this.resetValues();
      }
    },
    async getQuestions() {
      const start = (this.page - 1) * ITEMS_PER_PAGE;
      const end = this.page * ITEMS_PER_PAGE - 1;
      let params = {
        range: [start, end]
      };
      if (this.filter === FILTER_OWN) {
        params.filter = {
          ClientId: localStorage.ClientId
        };
      }
      const serviceResponse = await getQuestionsApi(params);
      if (serviceResponse.status) {
        this.questions = this.questions.concat(serviceResponse.data);
        this.total = serviceResponse.total;
        this.page++;
      } else {
        let message_obj = {
          message: serviceResponse.message.text,
          messageClass: "danger",
          autoClose: true
        };
        this.addMessage(message_obj);
      }
      return serviceResponse.status;
    }
  }
};
</script>

<style>
</style>